import React from "react";
import { Step } from "../ui/stepper";
import { LP_FAKE_FORM_STEPS as STEPS, STYLES } from "../../lib/constants";
import { DynamicEmbeddedWidget } from "@dynamic-labs/sdk-react-core";
import { useAuth } from "../auth/AuthProvider";
import { getNectarAuthUrl } from "../../lib/utils";
import { useGetStep } from "../../hooks/useGetStep";
import { GIRL_REALISM_ETHNICITY, GIRL_ANIME_RACE } from "../../lib/constants";
import { Button } from "../ui/button";
import { LockIcon, PlayIcon } from "lucide-react";

export const LandingFormAuth = ({ data }) => {
  const { user, handleLogOut } = useAuth();
  const step = useGetStep(
    data?.style === STYLES.REALISM ? GIRL_REALISM_ETHNICITY : GIRL_ANIME_RACE,
    data?.ethnicity
  );

  const image =
    step?.image ||
    "https://i.pinimg.com/736x/63/42/70/634270603e4880219de0015fc500a4ea.jpg";

  return (
    <Step id={STEPS.AUTH}>
      <div className="h-[100dvh] flex items-center justify-center flex-col gap-4">
        <div className="flex items-center gap-3 max-w-xs p-4 bg-background-500 border rounded-full">
          <div className="size-16 rounded-full overflow-hidden flex-shrink-0 relative">
            <img
              src={image}
              alt="heart logo icon"
              className="size-full object-cover blur-sm"
            />

            <LockIcon className="size-5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
          </div>
          <p className="font-medium">
            The creation of your AI Girlfriend is complete!
          </p>
        </div>
        {!user ? (
          <div className="max-w-sm w-full border rounded-2xl">
            <DynamicEmbeddedWidget />
          </div>
        ) : (
          <div className="flex flex-col gap-2">
            <Button
              onClick={() => {
                const authURL = getNectarAuthUrl("/pricing");
                window.location.href = authURL;
              }}
              className="h-14 px-8"
            >
              See your AI Girlfriend
            </Button>
            <button
              className="text-sm underline text-foreground-800"
              onClick={handleLogOut}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </Step>
  );
};
